/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type MoveIssuerRequestBody = {
  /**
   * The remote_session_issuer id.
   */
  id: string;
  /**
   * Target owning project id; the project must belong to the caller's organization. Omit to make the issuer organization-level.
   */
  projectId?: string | undefined;
};

/** @internal */
export type MoveIssuerRequestBody$Outbound = {
  id: string;
  project_id?: string | undefined;
};

/** @internal */
export const MoveIssuerRequestBody$outboundSchema: z.ZodMiniType<
  MoveIssuerRequestBody$Outbound,
  MoveIssuerRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    projectId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
    });
  }),
);

export function moveIssuerRequestBodyToJSON(
  moveIssuerRequestBody: MoveIssuerRequestBody,
): string {
  return JSON.stringify(
    MoveIssuerRequestBody$outboundSchema.parse(moveIssuerRequestBody),
  );
}
